import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VForm,
    {
      ref: "formAddRegion",
      staticClass: "form mt-2",
      attrs: { "lazy-validation": "" },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        VRow,
        { attrs: { dense: "" } },
        [
          _c(
            VCol,
            { attrs: { cols: "3" } },
            [
              _c(VSubheader, { staticClass: "font-weight-bold" }, [
                _vm._v("Nombre"),
              ]),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "9" } },
            [
              _c(VTextField, {
                attrs: {
                  outlined: "",
                  "hide-details": "auto",
                  dense: "",
                  rules: [
                    function (v) {
                      return !!v || this$1.translate("reglas.field")
                    },
                  ],
                },
                model: {
                  value: _vm.regionToAdd,
                  callback: function ($$v) {
                    _vm.regionToAdd = $$v
                  },
                  expression: "regionToAdd",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "3" } },
            [
              _c(VSubheader, { staticClass: "font-weight-bold" }, [
                _vm._v("Region DataEntry"),
              ]),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "9" } },
            [
              _c(VSelect, {
                attrs: {
                  name: "id_region",
                  label: _vm.$t("customer_insights.label.region"),
                  placeholder: _vm.$t("customer_insights.label.region"),
                  chips: "",
                  outlined: "",
                  dense: "",
                  items: _vm.regionsList,
                  "item-value": "id_region",
                  "item-text": "name",
                },
                model: {
                  value: _vm.id_region_dataentry,
                  callback: function ($$v) {
                    _vm.id_region_dataentry = $$v
                  },
                  expression: "id_region_dataentry",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }